<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <v-container>
          <v-row>
            <v-col>
              <DocumentLineViewer
                  ref="documentLineViewer"
                  :taskInfo="taskInfo"
                  :service="offerDocumentationService"
                  @selectedOffer="v => { $refs.offerDocumentationForm.setEditData(v); signedOffer = v }"
                  :disabled="isSigned"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <OfferDocumentationForm
                  view-only
                  ref="offerDocumentationForm"
                  hide-button
                  @closeDialog="closeDialog"
              />
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="6">
              <BaseButton
                  color="primary"
                  elevation="0"
                  outlined
                  v-show="!isSigned"
                  :btnText="$t('buttons:select-specific', { specific: $t('book/issue:offerDocumentation') })"
                  @clickedButton="signTask"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="offerId" outlined :read-only="isSigned" :label="$t('common:reason')" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import DocumentLineViewer from '@/modules/book/views/task/components/DocumentLineViewer';
import OfferDocumentationService from '@/modules/book/services/task-documentation/offer-documentation-service';
import OfferDocumentationForm from '@/modules/book/views/task/components/OfferDocumentationForm.vue';
import BaseButton from "@/modules/core/components/Base/BaseButton.vue";

export default {
  name: 'OfferSignDialog',
  components: {
    BaseButton,
    OfferDocumentationForm,
    DocumentLineViewer
  },
  props: {
    taskInfo: {},
    isSigned: Boolean
  },
  data() {
    return {
      signedOffer: {},
      dialog: false,
      wasRequired: true,
      offerId: null,
      offerDocumentationService: OfferDocumentationService,
      item: {},
      height: null

    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.documentLineViewer.clearData();
      this.$emit('closeDialog');
    },
    openDialog() {
      this.dialog = true;
      if (!this.taskInfo) return;

      if (this.taskInfo.signedOffer) {
        this.$refs.documentLineViewer.setActiveDocument(this.taskInfo.signedOffer);
      } else {
        this.$refs.documentLineViewer.setActiveDocument();
      }

      if (this.taskInfo.externalOfferId) {
        this.offerId = this.taskInfo.externalOfferId;
      }
    },
    signTask() {
      let task = this.taskInfo;
      task.signedOffer = this.signedOffer.id;
      task.externalOfferId = this.offerId;
      this.$emit('updateTask', task);
    }
  }
}
</script>

